import { useState, useEffect } from 'react';
import { Button, Sheet } from '@elbklar/ui';
import { TextField } from '@/components/form/Felder';

interface FollowUpModalProps {
  open: boolean;
  /** Vorbelegung als ISO-Zeitstempel, z. B. die bisherige Wiedervorlage. */
  initialValue?: string | null;
  onCancel: () => void;
  /** Liefert den gewaehlten Zeitpunkt als ISO-Zeitstempel (UTC). */
  onSubmit: (followUpAt: string) => void;
}

// datetime-local will "JJJJ-MM-TTTHH:MM" in Ortszeit; ein ISO-Zeitstempel aus
// der API hat Sekunden und Zeitzone und passt so nicht in das Feld.
export function toDatetimeLocal(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => `${n}`.padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromDatetimeLocal(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

/**
 * Wiedervorlage fuer den Status „Interessiert aber spaeter".
 *
 * Das Backend verlangt dafuer ``follow_up_at`` (CustomerUpdate-Validator);
 * ein Statuswechsel ohne Datum ergab bis zum 22.10.2026 ein 422, das die
 * Kundenliste ohne Meldung verschluckte (Audit CRM-1). Gegenstueck zu
 * LostReasonModal, gleiche Bedienung an jeder Stelle.
 */
export function FollowUpModal({ open, initialValue, onCancel, onSubmit }: FollowUpModalProps) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open) setValue(toDatetimeLocal(initialValue));
  }, [open, initialValue]);

  const iso = fromDatetimeLocal(value);

  return (
    <Sheet
      open={open}
      onOpenChange={(offen) => !offen && onCancel()}
      title="Wiedervorlage"
      description="Wann der Kunde wieder angesprochen wird."
      footer={
        <>
          <Button variant="ghost" onClick={onCancel}>
            Abbrechen
          </Button>
          <Button variant="primary" onClick={() => iso && onSubmit(iso)} disabled={!iso}>
            Wiedervorlage speichern
          </Button>
        </>
      }
    >
      <TextField
        type="datetime-local"
        label="Wiedervorlage am"
        required
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </Sheet>
  );
}
